export function isCreditCardExpired(expiryYear: number | string, expiryMonth: number | string) {
  const parsedYear = Number(expiryYear);
  const parsedMonth = Number(expiryMonth);

  // Number() will return NaN if the input can't be parsed to a number.
  if (Number.isNaN(parsedYear) || Number.isNaN(parsedMonth)) {
    return false;
  }

  // Date expects month to be 0-indexed, which plays in our favor here
  // since we'll get the 1st of the next month at 00:00, which is the exact Date
  // we need to compare against.
  // example, January will be 1 here, but Date will consider it as February and
  // give us the Date February 1st at 00:00.
  const expiryDate = new Date(parsedYear, parsedMonth);

  return expiryDate.valueOf() < Date.now();
}
